import { useCallback } from 'react';
import { useErrorPanelStore } from '@stores/errorPanelStore';
import type { ErrorEntry } from '@typings/errorPanel';

interface UseErrorPanelReturn {
    setErrors: (scope: string, errors: ErrorEntry[]) => void;
    clearErrors: (scope: string) => void;
    clearAll: () => void;
}

const useErrorPanel = (): UseErrorPanelReturn => {
    const setStoreErrors = useErrorPanelStore((s) => s.setErrors);
    const clearStoreErrors = useErrorPanelStore((s) => s.clearErrors);
    const clearAllStoreErrors = useErrorPanelStore((s) => s.clearAll);

    const setErrors = useCallback(
        (scope: string, errors: ErrorEntry[]) => setStoreErrors(scope, errors),
        [setStoreErrors],
    );
    const clearErrors = useCallback(
        (scope: string) => clearStoreErrors(scope),
        [clearStoreErrors],
    );
    const clearAll = useCallback(
        () => clearAllStoreErrors(),
        [clearAllStoreErrors],
    );

    return { setErrors, clearErrors, clearAll };
};
export default useErrorPanel;
